import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { subscribeToNewsletter } from "../../services/firebase/newsletter";
import { createSubscription } from "../../services/firebase/subscribe";
export var createSubscriptionForm = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(data.newsletter && data.email)) {
                            _context.next = 3;
                            break;
                        }
                        _context.next = 3;
                        return subscribeToNewsletter(data.email);
                    case 3:
                        return _context.abrupt("return", createSubscription(data));
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee);
    }));
    return function createSubscriptionForm(_x) {
        return _ref.apply(this, arguments);
    };
}();
export var SubscriptionResultStatus;
(function (SubscriptionResultStatus) {
    SubscriptionResultStatus[SubscriptionResultStatus["NONE"] = 0] = "NONE";
    SubscriptionResultStatus[SubscriptionResultStatus["ERROR"] = 1] = "ERROR";
    SubscriptionResultStatus[SubscriptionResultStatus["SUCCESS"] = 2] = "SUCCESS";
})(SubscriptionResultStatus || (SubscriptionResultStatus = {}));
